import { render } from "./detail-view.vue?vue&type=template&id=554f1b60"
import script from "./detail-view.vue?vue&type=script&lang=js"
export * from "./detail-view.vue?vue&type=script&lang=js"

import "./detail-view.vue?vue&type=style&index=0&id=554f1b60&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__